import React, { Component } from 'react';
import ReactTable from "react-table";
import "react-table/react-table.css";
import { withRouter } from 'react-router-dom'
import couterpart from 'counterpart';
// import ReactTablePagination from './PaginationComponent';
import {ToastsContainer, ToastsStore} from 'react-toasts';

import {MdDeleteForever} from 'react-icons/md';
import MasterDataService from '../services/MasterDataService';

import WorkOrderDataService from '../services/WorkOrderDataService';
import AuthenticationService from '../services/AuthenticationService';
import WorkOrderUtil from '../utilities/WorkOrderUtil';

import {ICON_COLOR} from '../icon';

class WorkOrdersListByOrderId extends Component {
  constructor () {
    super();
    
    this.state = {
      orderId: null,
      selected: null,
      workOrders: [],
      allStatus: [],
      columns : [
        {
          id: "idx",
          accessor: "",
          width: 40,
          Cell: row =>(
            <div style={{ padding: "10px"}}>{row.index + 1}</div>
          )
        },        
        {
          Header: couterpart.translate('work_order_no'),
          accessor: 'workOrderNo',
          width: 150,
          Cell: row =>(
            this.linkToDetails(row)
          )          
        },{
          Header: couterpart.translate('work_order_code'),
          accessor: 'sku',
          filterable: false,
          filterMethod: (filter, row) =>
            row[filter.id].includes(filter.value)
        },{
          Header: couterpart.translate('work_order_urgent_level'),
          accessor: 'isUrgentByCustomer',
          width: 50,
          Cell: row => {
            row.styles['color'] = row.value === 1 ? 'red' : 'black';
            return row.value === 1 ? 'X' : '';
          },          
          filterable: false,
          filterMethod: (filter, row) =>
            row[filter.id].includes(filter.value)
        },{           
          Header: couterpart.translate('shop_pcode'),
          accessor: 'fullPCode',
          filterable: false  
        },{
          Header: couterpart.translate('work_order_store'),
          accessor: 'store',
          filterable: false,
          filterMethod: (filter, row) =>
            row[filter.id].includes(filter.value)
        },{
          Header: couterpart.translate('work_order_status'),
          accessor: 'status',
          width: 150,
          Cell: props => this.getStatusDescription(props.value)
        },{
          Header: couterpart.translate('ship_to'),
          accessor: 'shipTo',
          width: 70
        },{
          Header: couterpart.translate('item_type'),
          accessor: 'type',
          filterable: false,
          width: 50            
        },{
          Header: couterpart.translate('item_assigned_to'),
          accessor: 'designer',
          filterable: false,
          width: 70
        },{
          Header: couterpart.translate('work_order_worker'),
          accessor: 'workerFullName',
          filterable: false,
          width: 70              
        },{                     
            Header: couterpart.translate('work_order_store'),
            accessor: 'action',
            width: 150,
            Cell: row =>(
              <div style={{ textAlign: "center" }}>
                  {this.renderEditButton(row)}
              </div>
            )
      }]
    };
  }

  getStatusDescription(status){
    if (this.state.allStatus === undefined || this.state.allStatus === null){
        return status;
    }    
    let istatus = parseInt(status);
    let statusInfo = this.state.allStatus.find(x =>{
      return x.status === istatus;
    });
    if (statusInfo !== undefined){
      return statusInfo.statusDescVn;
    }   
    return status;     
  }

  renderEditButton(row){
    // const button_edit = couterpart.translate('button_edit');
    const button_delete = couterpart.translate('button_delete');

    if (AuthenticationService.isService()){
      return (<div>
              <button className="myButton" onClick={() => this.handleDelete(row.original)}>
              <MdDeleteForever color={ICON_COLOR}/>
              &nbsp;{button_delete}</button>
                </div>
              );
    }else{
      return (<></>);
    }
  }

  componentDidMount () {
    MasterDataService.retrieveAllStatus().then(data => {
      this.setState({ allStatus:  data}) 
    });
    let selectedIndex = WorkOrderUtil.getItem('orders.workorders.selectedIndex') ? parseInt(WorkOrderUtil.getItem('orders.workorders.selectedIndex')) : 0;
    this.setState({ selected: selectedIndex});
  }

  componentDidUpdate(){
    if ((this.props.orderId === null) || (this.props.orderId === undefined) || (this.state.orderId === this.props.orderId)){
      return;
    }
    WorkOrderDataService.retrieveWorkOrdersByOrderId(this.props.orderId).then(data => {
      if (data.message === undefined){
        console.log('data', data)
        this.setState({ workOrders:  data, orderId: this.props.orderId})
      }
    });
  }

  handleEdit(e){
    if (AuthenticationService.isDesigner()){
      this.props.history.push("/workOrders/design/" + e.id);
      return;
    }
    
    if (AuthenticationService.isAdmin()){
      this.props.history.push("/workOrders/edit/" + e.id);
      return;
    }

    if (AuthenticationService.isService()){
      this.props.history.push("/workOrders/service/" + e.id);
    }
  }

  handleEdit2(e){
    if (AuthenticationService.isDesigner()){
      this.props.history.push("/workOrders/design/" + e.original.id);
      return;
    }
    
    if (AuthenticationService.isAdmin()){
      this.props.history.push("/workOrders/edit/" + e.original.id);
      return;
    }

    if (AuthenticationService.isService()){
      this.props.history.push("/workOrders/service/" + e.original.id);
    }
  }


  handleView(e){
    this.props.history.push("/workOrders/view/" + e.id);
  }

  handlePrint(e){
    this.props.history.push("/workOrders/print/" + e.id);
  }

  handleDelete(e){
    if (e.status !== 30){
      ToastsStore.error(couterpart.translate('msg_delete_origin_workorder'));
    } else {
      // console.log('DELETE WO', e);
      let ret = window.confirm(couterpart.translate('msg_delete_workorder_cfm'));
      if (ret === true){
        WorkOrderDataService.deleteCloneWorkOrder(e.id).then(data => {
          if (data.message === undefined){
            WorkOrderDataService.retrieveWorkOrdersByOrderId(this.props.orderId).then(data => {
              if (data.message === undefined){
                if (data && data < 1){
                  this.props.callbackFunc()
                }
                this.setState({ workOrders:  data, orderId: this.props.orderId})
              }
            });
          }
        });
      }
    }
  }

  linkToDetails(row){
      return(
          <label className="label_link" href="#!" onClick={() => {this.handleEdit2(row)}}>{row.original.workOrderNo}</label>
      )
  }    

  render() {
    const work_orders_of_order = couterpart.translate('work_orders_of_order');
    return (
          <div>
              <hr/>
              <ToastsContainer store={ToastsStore} position="bottom_center" />
              <div><b>{work_orders_of_order} {this.props.orderNo}</b></div>
              <ReactTable
                NoDataComponent={() => null} 
                // PaginationComponent={ReactTablePagination}
                previousText={"<"}
                nextText={">"}              
                data={this.state.workOrders}
                columns={this.state.columns}
                defaultPageSize = {3}
                showPageSizeOptions = {true}
                pageSizeOptions = {[3, 5, 10, 20]}
                getTrProps={(state, rowInfo, column) => { 
                  if (rowInfo && rowInfo.row) {
                    return {
                      onClick: (e) => {
                        this.setState({
                          selected: rowInfo.index,
                          workOrderId: rowInfo.original.id
                        }, () => {
                          WorkOrderUtil.saveItem('orders.workorders.selectedIndex', this.state.selected)
                        })
                      },
                      style: {
                        background: rowInfo.index === this.state.selected ? '#DCDCDC' : 'white',
                        color: rowInfo.index === this.state.selected ? 'white' : 'black'
                      }
                    }
                  }else{
                    return {}
                  }
                }
              }
              />
          </div>      
    )
  }
}

export default withRouter(WorkOrdersListByOrderId);